import { PlusCircleOutlined, UnorderedListOutlined } from '@ant-design/icons';

const icons = {
  PlusCircleOutlined,
  UnorderedListOutlined,
};

const roles = {
  id: 'group-roles',
  title: 'Roles Managment',
  type: 'group',
  children: [
    {
      id: 'roles-list',
      title: 'List of roles',
      type: 'item',
      url: '/',
      icon: icons.UnorderedListOutlined,
      breadcrumbs: false,
    },
    {
      id: 'roles-create',
      title: 'Create a new role',
      type: 'item',
      url: '/',
      icon: icons.PlusCircleOutlined,
      breadcrumbs: false,
    },
  ],
};

export default roles;
